import { Invoice } from '@/app/invoice/entities/invoice.entity'

export interface InvoiceState {
    invoices: Invoice[]
}

export const state: InvoiceState = {
    invoices: []
}
